<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="5vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="P/N:" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.lotNo') + ':'" prop="lotNo">
            <el-input
              v-model.trim="form.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.waferNo') + ':'" prop="waferNo">
            <el-input
              v-model.trim="form.waferNo"
              name="waferNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count') + ':'" prop="qty">
            <el-input
              v-model.trim.number="form.qty"
              name="qty"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.binLevel') + ':'" prop="binLevel">
            <el-input
              v-model.trim="form.binLevel"
              name="binLevel"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            :id="labelName"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {validateCount, validateLotNo} from "@/utils/validate";
import {
  initBoxLabelFrame, initCommonLabelFrame, printFactoryLabel,
} from '@/utils/factory-label';

export default {
  name: "boxLabelDialog",
  props: {
    factoryName: {
      type: String,
      default: '',
    },
    labelName: {
      type: String,
      default: 'labelIFrameBoxLabelDialog',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        partNo: undefined,
        lotNo: undefined,
        waferNo: undefined,
        qty: undefined,
        binLevel: undefined
      },
      rules: {
        partNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.partNoCanNotBeEmpty')
        }],
        lotNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('validate.lotNoCanNotBeEmpty')
        }],
        waferNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('validate.waferNoCanNotBeEmpty')
        }],
        qty: [{
          required: true,
          trigger: 'blur',
          validator: validateCount
        }],
      },
    };
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.initBoxLabelFrame();
        });
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.printBoxLabelFrame();
        }
      });
    },
    initBoxLabelFrame() {
      let iframe = document.getElementById(this.labelName);
      iframe = initBoxLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'HPA573#003#1',
        waferNo: '1-1',
        qty: 1500,
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    printBoxLabelFrame() {
      const {
        partNo,
        lotNo,
        waferNo,
        qty,
        binLevel,
      } = this.form;
      let iframe = document.getElementById(this.labelName);
      iframe = initBoxLabelFrame({
        iframe,
        partNo,
        lotNo,
        waferNo,
        qty,
        binLevelExplain: binLevel,
      });
      iframe.contentWindow.document.close();
      printFactoryLabel(iframe);
    },
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
  padding: 10px 15px;
  align-items: center;
}

.title-text {
  color: #404040;
  font-size: 16px;
}

.el-form {
  margin: 0 30px;
}

.close-image {
  width: 22px;
  height: 22px;
  cursor: pointer;
  padding: 0 10px;
}
</style>
  <style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
